import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/utilisateur/utilisateurCompte.css";
import { AuthContext } from "../../contexts/AuthContext";
import { useNotificationRealtime } from "../../contexts/NotificationContext";

const UtilisateurCompte = () => {
  const { logout, user: ctxUser } = useContext(AuthContext);
  const { unreadCount } = useNotificationRealtime();
  const navigate = useNavigate();

  const user =
    ctxUser ||
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  // Menu standard
  const menuItems = [
    {
      label: "Mon profil",
      icon: "person",
      onClick: () => navigate("/utilisateur/profil"),
    },
    {
      label: "Mes annonces",
      icon: "megaphone",
      onClick: () => navigate("/utilisateur/mesAnnonces"),
    },
    {
      label: "Mes paiements",
      icon: "credit-card",
      onClick: () => navigate("/paiement/mesPaiements"),
    },
    {
      label: "Notification",
      icon: "bell",
      onClick: () => navigate("/notification"),
      badge: unreadCount,
    },
    {
      label: "Contact",
      icon: "envelope",
      onClick: () => navigate("/contact"),
    },
  ];

  // Menus admin (ajout Dashboard)
  const adminMenuItems = [
    {
      label: "Dashboard",
      icon: "speedometer2",
      onClick: () => navigate("/admin/dashboard"),
      highlight: true, // optionnel pour un style différent
    },
    {
      label: "Liste utilisateurs",
      icon: "people",
      onClick: () => navigate("/admin/utilisateurs"),
    },
    {
      label: "Liste articles",
      icon: "file-earmark-text",
      onClick: () => navigate("/admin/articles"),
    },
    {
      label: "Liste paiements",
      icon: "credit-card",
      onClick: () => navigate("/admin/paiements"),
    },
    {
      label: "Liste catégories",
      icon: "tags",
      onClick: () => navigate("/admin/categories"),
    },
    {
      label: "Liste groupes catégories",
      icon: "tags-fill",
      onClick: () => navigate("/admin/groupCategorie"),
    },
        {
      label: "Liste coupons",
      icon: "wallet",
      onClick: () => navigate("/admin/coupons"),
    },
    {
      label: "Sondages",
      icon: "clipboard data",
      onClick: () => navigate("/admin/sondages"),
    },
    {
      label: "Configuration questionnaire",
      icon: "gear",
      onClick: () => navigate("/admin/sondages/questions"),
    },
    {
      label: "Journal des erreurs",
      icon: "journal",
      onClick: () => navigate("/admin/journal"),
    },
    {
      label: "Signalements",
      icon: "exclamation-triangle",
      onClick: () => navigate("/admin/signalements"),
    },
  ];
  const readOnlyItem = [
    {
      label: "Dashboard",
      icon: "speedometer2",
      onClick: () => navigate("/admin/dashboard"),
      highlight: true, // optionnel pour un style différent
    },
        {
      label: "Liste utilisateurs",
      icon: "people",
      onClick: () => navigate("/admin/utilisateurs"),
    },
    {
      label: "Liste articles",
      icon: "file-earmark-text",
      onClick: () => navigate("/admin/articles"),
    },
        {
      label: "Liste paiements",
      icon: "credit-card",
      onClick: () => navigate("/admin/paiements"),
    },
  ];

  return (
    <div className="container utilisateur_compte_container">
      <i
        className="bi bi-x-circle login_icon_x"
        role="button"
        onClick={() => navigate("/")}
      ></i>

      <div className="utilisateur_compte_header">
        <h1>{user?.prenom}</h1>
        <p className="text-uppercase">
          {user?.tel || ""} {user?.ville ? `, ${user.ville}` : ""}
        </p>
      </div>

      {/* Menu utilisateur */}
      <div className="utilisateur_compte_menu">
        {menuItems.map((item, index) => (
          <div
            key={index}
            className={`utilisateur_compte_menu_item ${
              item.badge ? "notif_menu_item" : ""
            }`}
            onClick={item.onClick}
            style={{ position: item.badge ? "relative" : "static" }}
          >
            <i className={`bi bi-${item.icon}`}></i>
            <span>{item.label}</span>
            {item.badge > 0 && (
              <span className="utilisateur_compte_notification">
                {item.badge}
              </span>
            )}
          </div>
        ))}

        {/* Séparation si admin */}
        {user?.role == 1 && adminMenuItems.length > 0 && (
          <>
            <div className="utilisateur_compte_header mt-5">
              <h1>Admin</h1>
              <p className="text-uppercase"></p>
            </div>

            {adminMenuItems.map((item, index) => (
              <div
                key={index}
                className={`utilisateur_compte_menu_item ${
                  item.highlight ? "admin_menu_item_highlight" : ""
                }`}
                onClick={item.onClick}
              >
                <i className={`bi bi-${item.icon}`}></i>
                <span>{item.label}</span>
              </div>
            ))}
          </>
        )}
        {/* Séparation si admin */}
        {user?.role == 3 && adminMenuItems.length > 0 && (
          <>
            <div className="utilisateur_compte_header mt-5">
              <h1>Admin</h1>
              <p className="text-uppercase"></p>
            </div>

            {readOnlyItem.map((item, index) => (
              <div
                key={index}
                className={`utilisateur_compte_menu_item ${
                  item.highlight ? "admin_menu_item_highlight" : ""
                }`}
                onClick={item.onClick}
              >
                <i className={`bi bi-${item.icon}`}></i>
                <span>{item.label}</span>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="utilisateur_compte_logout">
        <div className="utilisateur_compte_menu_item" onClick={logout}>
          <i className="bi bi-box-arrow-left"></i>
          <span>Déconnexion</span>
        </div>
      </div>

      <div className="utilisateur_compte_action mb-4 mt-4">
        <button onClick={() => navigate("/article/creation")}>
          <i className="bi bi-plus-circle-fill"></i>
          <span>Publier une annonce</span>
        </button>
      </div>
    </div>
  );
};

export default UtilisateurCompte;
